<template>
  <button
    type="button"
    v-bind="$attrs"
    :class="`ml-4 box-border h-10 border-4 border-${color} `"
    style="background: rgba(0, 0, 0, 0.5)"
    disabled
  >
    <div class="flex flex-row items-center justify-center">
      <WaitYellow width="20px" height="20px" class="mr-1 mt-0.5" />
      <div class="flex flex-row items-baseline">
        <span class="text-lg text-white leading-tight font-bold">確認待</span>
        <span
          v-if="isAuthorizer === 0"
          class="text-lg text-white leading-tight"
        >
          ｜修正の場合は取下げてください
        </span>
      </div>
      <div
        class="flex items-center absolute right-0 mr-1"
        style="flex-direction: row-reverse;"
        :style="isAuthorizer === 0 ? 'right: 190px;' : ''"
      >
        <ul v-for="total of totalApprove" :key="total">
          <approved-icn
            v-if="
              (total == 3 && count === 3) ||
                (total == 2 && count >= 2) ||
                (total == 1 && count >= 1)
            "
            class="mr-1"
            width="20px"
            height="20px"
          >
          </approved-icn
          ><approved-not-circle-icn
            v-if="
              (total == 3 && count !== 3) ||
                (total == 2 && count <= 1) ||
                (total == 1 && count === 0)
            "
            class="mr-1 border-2 border-dotted light-green-icon"
            style="border-radius: 10px; border-color:#08D61C;"
            width="20px"
            height="20px"
          ></approved-not-circle-icn>
        </ul>
      </div>
    </div>
  </button>
</template>

<script>
import WaitYellow from '@/assets/icons/wait-yellow.svg?inline'
import ApprovedIcn from '@/assets/icons/approved.svg?inline'
import ApprovedNotCircleIcn from '@/assets/icons/approved-not-circle.svg?inline'
export default {
  name: 'AppWaitingBtn',

  props: {
    color: String,
    isAuthorizer: Number,
    count: Number,
    totalApprove: Number,
  },

  components: { WaitYellow, ApprovedIcn, ApprovedNotCircleIcn },
}
</script>
<style lang="scss" scoped>
button {
  border-radius: 20px;
  width: 510px;
}

.yellow-circle {
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: #f0c000;
  margin-left: 4px;
  margin-right: 4px;
}
</style>
